import { Routes } from "@angular/router";

export const sendEvaluationFormListRoutes: Routes = [
  {
    path: "",
    title: "FRIENDS_OF_OMAN_MUSEUM.TARGETED_MESSAGES",
    loadComponent: () =>
      import("./pages/send-evaluation-form-list/send-evaluation-form-list.component").then((m) => m.SendEvaluationFormListComponent),
  },
];
